import React from "react";
import "./Footer.css";
import { Link } from "react-scroll";
import { motion } from "framer-motion";
import { FaInstagram, FaFacebookF, FaLinkedin } from "react-icons/fa";
// import { FaX } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* Footer Info */}
            <div className="col-lg-4 col-md-6 footer-info">
              <div id="tp">
                <motion.img
                  id="logo2"
                  src="/images/Logo-copy.png"
                  alt="PodSutra Logo"
                  style={{ width: "150px" }}
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: "spring", stiffness: 300, damping: 10 }}
                />

                <p className="p2" style={{ width: "70%", marginLeft: "3%" }}>
                  The Podsutra is a premium podcast recording and production
                  studio designed for creators, storytellers, and professionals.
                </p>

                {/* Social Media Icons */}
                <div className="social-links">
                  <a
                    href="https://www.instagram.com/thepodsutra.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram className="social-icon" />
                  </a>
                  {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <FaX className="social-icon" />
                </a> */}
                  <a
                    href="https://www.facebook.com/people/The-PodSutra-Studios/61572483781303/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="social-icon" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/the-podsutra-studios/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin className="social-icon" />
                  </a>
                  {/* <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                  <FaYoutube className="social-icon" />
                </a> */}
                </div>
              </div>
            </div>

            {/* Useful Links */}
            <div className="col-lg-4 col-md-6 footer-links" style={{fontSize:"18px"}}>
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <Link to="Hero" smooth={true} duration={500}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="Process" smooth={true} duration={500} offset={-80}>
                    Process
                  </Link>
                </li>
                <li>
                  <Link to="Studio" smooth={true} duration={500} offset={-80}>
                    Facilities
                  </Link>
                </li>
                <li>
                  <Link to="StudioImg" smooth={true} duration={500}>
                    Studio
                  </Link>
                </li>
                <li>
                  <Link to="Contact" smooth={true} duration={500} offset={-210}>
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="col-lg-4 col-md-6 footer-contact">
              <h4>Contact Us</h4>
              <p className="footeralign">
                109,
                <br />
                Triumph Plaza, <br />
                Canal road, Gaurav Path Road, Surat, Gujarat 395009 <br />
                <strong>Phone:</strong> +91 76220 04433 <br />
                <strong>Email:</strong> thepodsutra@gmail.com <br />
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="container footer-bottom">
        <p>
          &copy; {new Date().getFullYear()}{" "}
          <strong>
            <a
              href="https://www.bemotion.in/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Bemotion
            </a>
          </strong>{" "}
          All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
